export default [
  {
    path: 'users',
    name: 'users',
    meta: {
      meta: {
        requiredPrivileges:  ['system settings']
      },
    },
    component: () =>
      import('@/modules/global-settings/security/views/UsersPage.vue')
  },
  {
    path: 'roles',
    name: 'roles',
    meta: {
      requiredPrivileges:  ['system settings']
    },
    component: () =>
      import('@/modules/global-settings/security/views/RolePage.vue')
  }
];
